// File: frontend/src/index.js

/*
  Main entry point for the React application.
  - Mounts the root App component to the DOM
  - Enables StrictMode for highlighting potential problems
  - Starts performance monitoring with reportWebVitals
*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CLERK_PUBLISHABLE_KEY } from './config';
import { clerkAppearance, clerkLocalization } from './config/clerkAppearance';

// Create root and render App inside StrictMode
const root = ReactDOM.createRoot(document.getElementById('root'));

// Clerk requires a publishable key. Add REACT_APP_CLERK_PUBLISHABLE_KEY to frontend/.env
const ClerkApp = () => {
  if (!CLERK_PUBLISHABLE_KEY) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
        <h1>Setup required</h1>
        <p>Add <code>REACT_APP_CLERK_PUBLISHABLE_KEY</code> to <code>frontend/.env</code>.</p>
        <p>Get your key from <a href="https://dashboard.clerk.com" target="_blank" rel="noreferrer">dashboard.clerk.com</a> → API Keys.</p>
      </div>
    );
  }
  // Sign-out: redirect to our embedded /sign-in page
  const signOutUrl = typeof window !== 'undefined' ? `${window.location.origin}/sign-in` : '/sign-in';
  return (
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      appearance={clerkAppearance}
      localization={clerkLocalization}
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl={signOutUrl}
    >
      <App />
    </ClerkProvider>
  );
};

root.render(
  <React.StrictMode>
    <ClerkApp />
  </React.StrictMode>
);

// Start measuring performance (optional)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
